/* eslint-disable*/
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, delay, map, tap } from 'rxjs/operators';
import BaseService from 'libs/shared-lib1/src/lib/shared/base.service';
import { ConfigService } from 'libs/shared-lib1/src/lib/shared/services/config-service.service';

@Injectable({
  providedIn: 'root',
})

////https://indepth.dev/tutorials/angular/authentication-token-interceptor
export class AuthService {
  private isLoggedIn = new BehaviorSubject<boolean>(null);

  isLoggedInAsObservable = this.isLoggedIn.asObservable();

  //private loggedInSuccessfully = JSON.parse(localStorage.getItem('loggedIn') || 'false');

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private baseService: BaseService,
    private configService: ConfigService
  ) { }

  setIsLoggedIn(isLoggedIn: boolean) {
    this.isLoggedIn.next(isLoggedIn);
  }

  getAuthToken(): string | null {
    //let authToken: string | null = 'getMeFromLocalStoage'
    let authToken = this.cookieService.get('authTokenFromBackend');
    //TODO GET FROM COOKIE
    //authToken = window.localStorage.getItem("accessTokenFromAzure");

    return authToken;
  }

  trySignInAndGetAuthTokenFromBackend(
    userName: string,
    Password: string,
    settings: any
  ): Observable<string> {
    let retVal: string; //Movie[] = new Array<Movie>();

    //let settings = this.configService;
    let settingsReceived = settings;

    this.baseService.initializeBaseUrl(
      'https://localhost:7102',
      'https://itai-net-core.azurewebsites.net',
      settingsReceived
    );

    //TODO
    //https://localhost:7102/api/TryLoginWithUserAndPass/itai/itai

    //https://localhost:7102/api/TryLoginWithUserAndPass/itai/itai


    var url =
      this.baseService.baseUrl + '/api/TryLoginWithUserAndPass/Itai/Itai';

    return this.http.get<any>(url).pipe(

      map((response: any) => {

        retVal = response.value; //null;//this.mapResponseToRetVal(response.value);

        var cookieObjProps = { path: "/" }
        this.cookieService.set('authTokenFromBackend', retVal, cookieObjProps);

        return retVal;

      }),
      catchError((error: HttpErrorResponse) => {

        let errroAsString: string = error.message;

        //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
        return throwError(() => errroAsString);

      })

    );
  }

  logOut() {

    //var cookieObjProps = { expires: 2, sameSite: 'Lax', path:  "/"};
    var cookieObjProps = { path: "/" };

    this.cookieService.set('authTokenFromBackend', '', cookieObjProps);
    this.cookieService.set('loggedIn', 'false', cookieObjProps);
  }

}
